import { getMetricValue } from 'common/pages/fleetV2/machine/dsi/components/IntensifierWidgets/IntensifierLineChartWidget'

export const INTENSIFIER_KEYS = ['int1', 'int2', 'int3', 'int4']

export const responseRows = (response?: Record<string, unknown>): Record<string, unknown>[] => {
  const rows = Array.isArray(response) ? response : Array.isArray(response?.data) ? response?.data : []
  return rows as Record<string, unknown>[]
}

export const chunkRows = (response?: Record<string, unknown>): Record<string, unknown>[] =>
  responseRows(response).flatMap(row => {
    const timestamp = String(row?.start_datetime_utc || row?.group || row?.timestamp || '')
    if (!timestamp) return []
    const values = Object.fromEntries(INTENSIFIER_KEYS.map(key => [key, row?.[`${key}_disabled`] ? undefined : getMetricValue(row, key)]))
    const total = Object.values(values).reduce((sum: number, value) => sum + (value ?? 0), 0)
    return [{ ...values, timestamp, total }]
  })
